import React from "react";
import { v4 } from "uuid";

const checkBox = (props) => {
  const id = v4();
  return (
    <div className="checkbox-container">
      <div className="pr-3">
        <input
          id={id}
          type="checkbox"
          className="custom-checkbox"
          checked={props.checked}
          onChange={props.checkHandler}
        />
      </div>
      {props.title ? (
        <label className="title" htmlFor={id}>
          {props.title}
        </label>
      ) : null}
    </div>
  );
};

export default checkBox;
